import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter)

const scrollBehavior = (to, from, savedPosition) => {
    if (savedPosition) {
        return savedPosition
    } else {
        return {x: 0, y: 0}
    }
}


const routes = [

    {
        path: '/',
        name: 'Home',
        component: Home,
        redirect: '/index.html',
        children: [
            {
                path: '/index.html',
                name: 'index',
                component: () => import('@/views/Index.vue'),
                meta: {
                    title: '首页-南京星谱智科技有限公司'
                }
            },
            {
                path: '/about.html',
                name: 'about',
                component: () => import('@/views/About.vue'),
                meta: {
                    title: '关于我们-南京星谱智科技有限公司'
                }
            },
            // {
            //     path: '/solution',
            //     name: 'about',
            //     component: () => import('@/views/About.vue')
            // },

            {
                path: '/monitor.html',
                name: 'monitor',
                component: () => import('@/views/solution/pinpujiance/Index.vue'),
                meta: {
                    title: '频谱监测-南京星谱智科技有限公司'
                }
            },
            {
                path: '/mapping.html',
                name: 'mapping',
                component: () => import('@/views/solution/cehui/Index.vue'),
                meta: {
                    title: '测绘系统-南京星谱智科技有限公司'
                }
            },
            {
                path: '/direction-finding.html',
                name: 'mapping',
                component: () => import('@/views/solution/cexiang/Index.vue'),
                meta: {
                    title: '测向系统-南京星谱智科技有限公司'
                }
            },
            {
                path: '/fanwu.html',
                name: 'fanwu',
                component: () => import('@/views/solution/fanwu/Index.vue'),
                meta: {
                    title: '反无系统-南京星谱智科技有限公司'
                }
            },
            {
                path: '/xingzhi-u1.html',
                name: 'xingzhi',
                component: () => import('@/views/solution/xingzhiyunhe/Index.vue'),
                meta: {
                    title: '星智云盒U1-南京星谱智科技有限公司'
                }
            },
            {
                path: '/uav.html',
                name: 'uav',
                component: () => import('@/views/solution/uav/Index.vue'),
                meta: {
                    title: '抗干扰无人机-南京星谱智科技有限公司'
                }
            },
            {
                path: '/ibos.html',
                name: 'ibos',
                component: () => import('@/views/solution/ibos/Index.vue'),
                meta: {
                    title: 'IBOS-南京星谱智科技有限公司'
                }
            },
            {
                path: '/news.html',
                name: 'news',
                component: () => import('@/views/News.vue'),
                meta: {
                    title: '新闻中心-南京星谱智科技有限公司'
                }
            },
            {
                path: '/talent.html',
                name: 'talent',
                component: () => import('@/views/Talent.vue'),
                meta: {
                    title: '人力资源-南京星谱智科技有限公司'
                }
            },
            {
                path: '/contactUs.html',
                name: 'contactUs',
                component: () => import('@/views/ContactUs.vue'),
                meta: {
                    title: '联系我们-南京星谱智科技有限公司'
                }
            },
        ],
        scrollBehavior
    },

]


const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})

export default router
